import { InfoOutlined } from "@mui/icons-material"
import { Box, CircularProgress, Typography } from "@mui/joy"
import { useFeeCollection } from "../context/FeeCollectionContext"
import { getClassNameByValue } from "utilities/UtilitiesFunctions"

function StudentInfoSection() {

    const { student: studentMasterData } = useFeeCollection()

    if (!studentMasterData) {
        return <CircularProgress />
    }

    return (
        <Box>
            <Typography level="title-lg" startDecorator={<InfoOutlined />} color="primary" mt={2.5}>Student Details</Typography>
            <Box sx={{ border: "1px solid oklch(.900 .013 255.508)", borderRadius: "10px", padding: "6px", mt: 1, display: "flex", gap: 1, }}>
                <Box sx={{ display: "flex", flex: 1 }}>
                    <div style={{ margin: "10px" }}>
                        <img
                            src={studentMasterData.profil_url || "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ4YreOWfDX3kK-QLAbAL4ufCPc84ol2MA8Xg&s"}
                            width={120}
                            height={150}
                            style={{ objectFit: "cover" }}
                            alt="student_profile_picture"
                        ></img>
                    </div>
                    <div
                        style={{
                            margin: "8px 10px 8px 0px",

                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                        }}
                    >
                        <div>
                            <Typography
                                level="h4"
                                sx={{ fontWeight: "500" }}
                                textTransform="uppercase"
                            >
                                {studentMasterData.student_name}
                            </Typography>
                            <Typography level="body-sm">
                                Father's Name : {studentMasterData.father_name}
                            </Typography>
                            <Typography level="body-sm">
                                Student's ID: {studentMasterData.admission_no}
                            </Typography>
                        </div>
                        <div
                            style={{
                                backgroundColor: "#F0F4F8",
                                display: "flex",

                                borderRadius: "8px",
                                gap: "20px",
                                marginTop: "10px",
                                padding: "10px 16px",

                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                }}
                            >
                                <Typography level="body-sm">Class</Typography>
                                <Typography level="title-sm">
                                    {getClassNameByValue(studentMasterData.class!)}
                                    {/* {location.state[0].class} */}
                                </Typography>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                }}
                            >
                                <Typography level="body-sm">Roll</Typography>
                                <Typography level="title-sm">
                                    {studentMasterData.rollNumber}
                                </Typography>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                }}
                            >
                                <Typography level="body-sm">Admission Date</Typography>
                                <Typography level="title-sm">
                                    {studentMasterData.date_of_addmission}
                                </Typography>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                }}
                            >
                                <Typography level="body-sm">Fee</Typography>
                                <Typography level="title-sm">
                                    ₹{studentMasterData.monthly_fee ? studentMasterData.monthly_fee : 0}
                                </Typography>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                }}
                            >
                                <Typography level="body-sm">Discount</Typography>
                                <Typography level="title-sm">
                                    ₹{studentMasterData.fee_discount ? studentMasterData.fee_discount : 0}
                                </Typography>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                }}
                            >
                                <Typography level="body-sm">Transport</Typography>
                                <Typography level="title-sm">
                                    ₹{studentMasterData.transportation_fee ? studentMasterData.transportation_fee : 0}
                                </Typography>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                }}
                            >
                                <Typography level="body-sm">Computer</Typography>
                                <Typography level="title-sm">
                                    ₹{studentMasterData.computer_fee ? studentMasterData.computer_fee : 0}
                                </Typography>
                            </div>
                        </div>
                    </div>

                </Box>
            </Box>
        </Box>
    )
}

export default StudentInfoSection